<div 
  class="tree-group" 
  [ngClass]="{ 
    'tree-group--light': theme === treeTheme.Light,
    'tree-group--themed': theme === treeTheme.Themed
  }"
  *ngFor="let node of nodes; trackBy: trackTreeNode">
  
  <app-tree-nested-node 
    [graph]="graph" 
    [node]="node"
    [theme]="theme">
  </app-tree-nested-node>

  <div class="tree-group__children" *ngIf="node.boolState.expanded">
    <!-- Collapser -->
    <div 
      class="tree-group__collapse" 
      *ngIf="hasChildren(node)" 
      (click)="handleExpandClick(node, true)" 
      [title]="node.label"></div>
    
    <!-- Children -->
    <app-tree-group 
      [graph]="graph" 
      [node]="node"
      [theme]="theme"
      (clickNode)="handleNodeClick($event)"></app-tree-group>
  </div>
</div>
